// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"348":"a3732c10","425":"959fca69","512":"959fca69","568":"959fca69","773":"959fca69"}[chunkId] + ".chunk.css";
};